import { createSlice } from "@reduxjs/toolkit";
import { api } from "service/api";
import { Toast } from "service/toast";
import { ActivityApi } from "service/apiVariables";
import { NO_DATA, addQuery } from "helpers/utis";
import { setLoader } from "./loader";

export const activitySlice = createSlice({
  name: "activity",
  initialState: {
    activityData: "",
    inActiveActivityData: "",
    tradeData: "",
    activityDetail: null,
    isLoading: true,
    uomData: "",
    regionData: "",
    selectedTrade: null,
    activeRegion: null,
    inactiveRegion: null,
  },
  reducers: {
    saveTradeData: (state, action) => {
      state.tradeData = action.payload;
    },
    saveActivityData: (state, action) => {
      state.activityData = action.payload;
      state.isLoading = false;
    },
    saveInactiveActivityData: (state, action) => {
      state.inActiveActivityData = action.payload;
      state.isLoading = false;
    },
    saveActivityDetail: (state, action) => {
      state.activityDetail = action.payload;
      state.isLoading = false;
    },
    saveUomData: (state, action) => {
      state.uomData = action.payload;
      state.isLoading = false;
    },
    saveRegionData: (state, action) => {
      state.regionData = action.payload;
      state.isLoading = false;
    },
    setSelectedTrade: (state, action) => {
      state.selectedTrade = action.payload;
    },
    clearSelectedTrade: (state) => {
      state.selectedTrade = null;
    },
    setSelectedActiveRegion: (state, action) => {
      state.activeRegion = action.payload;
    },
    setSelectedInActiveRegion: (state, action) => {
      state.inactiveRegion = action.payload;
    },
  },
});

// get all activity
export const getAllActivityAct = (query) => (dispatch) => {
  addQuery(query, ActivityApi.getActivityApi);
  return new Promise((resolve, reject) => {
    api({ ...ActivityApi.getActivityApi })
      .then(({ data, message }) => {
        dispatch(saveActivityData(data));
        dispatch(setLoader(false));
      })
      .catch(({ message }) => {
        dispatch(setLoader(false));
        if (message === NO_DATA) {
          dispatch(saveActivityData([]));
        } else {
          reject(Toast({ type: "error", message }));
        }
      });
  });
};

// get all inactive activity
export const getInactiveActivityAct = (query) => (dispatch) => {
  addQuery(query, ActivityApi.getInactiveActivityApi);
  return new Promise((resolve, reject) => {
    api({ ...ActivityApi.getInactiveActivityApi })
      .then(({ data, message }) => {
        dispatch(saveInactiveActivityData(data));
        dispatch(setLoader(false));
      })
      .catch(({ message }) => {
        dispatch(setLoader(false));
        if (message === NO_DATA) {
          dispatch(saveInactiveActivityData([]));
        } else {
          reject(Toast({ type: "error", message }));
        }
      });
  });
};

// update activity status
export const updateActivityStatus = (activity_id, type) => () => {
  ActivityApi.updateActivityStatusApi.activity_id = activity_id;
  ActivityApi.updateActivityStatusApi.type = type;
  return new Promise((resolve, reject) => {
    api({ ...ActivityApi.updateActivityStatusApi })
      .then((data) => {
        Toast({ type: "success", message: data.message });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

// delete activity
export const deleteActivityAct = (id) => () => {
  ActivityApi.deleteActivity.activity_master_id = id;
  return new Promise((resolve, reject) => {
    api({ ...ActivityApi.deleteActivity })
      .then((data) => {
        Toast({ type: "success", message: data.message });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

// get single activity
export const getSingleActivityAct = (id, statusId, body) => (dispatch) => {
  ActivityApi.getSingleActivityApi.activity_master_id = id;
  ActivityApi.getSingleActivityApi.active_status = statusId;

  addQuery(body, ActivityApi.getSingleActivityApi);
  return new Promise((resolve, reject) => {
    api({ ...ActivityApi.getSingleActivityApi })
      .then(({ data }) => {
        dispatch(saveActivityDetail(data));
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

// add activity
export const createActivityAct = (body) => () => {
  return new Promise((resolve, reject) => {
    api({ ...ActivityApi.addActivityApi, body })
      .then((data) => {
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

// update activity
export const updateActivityAct = (body) => () => {
  return new Promise((resolve, reject) => {
    api({ ...ActivityApi.updateActivityApi, body })
      .then((data) => {
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

// activity dropdown
export const getActivityDropDownAct = (id) => () => {
  ActivityApi.getActivityDropDown.activity_trade_id = id;
  addQuery(ActivityApi.getActivityDropDown);
  return new Promise((resolve, reject) => {
    api({ ...ActivityApi.getActivityDropDown })
      .then((data) => resolve(data))
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

export const getTradeDropDownAct = () => (dispatch) => {
  return new Promise((reject) => {
    api({ ...ActivityApi.getTradeDropDown })
      .then((data) => {
        dispatch(saveTradeData(data));
        return data;
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

export const getUomDropDownAct = () => (dispatch) => {
  return new Promise((reject) => {
    api({ ...ActivityApi.getUomDropDown })
      .then((data) => {
        dispatch(saveUomData(data));
        return data;
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

export const getRegionsAct = () => (dispatch) => {
  return new Promise((reject) => {
    api({ ...ActivityApi.getRegionsApi })
      .then((data) => {
        dispatch(saveRegionData(data));
        return data;
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

//upload
export const activityFileUpload = (body) => () => {
  return new Promise((resolve, reject) => {
    api({ ...ActivityApi.activityUploadFileApi, body })
      .then((data) => {
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

// status of the bulk upload activity
export const getCronStatusReport = (body) => {
  const apiurl = ActivityApi.getProgessStatusAPI.api(body);

  return new Promise((resolve, reject) => {
    api({ api: apiurl, baseURL: "user" })
      .then((data) => {
        console.log(data);

        resolve(data);
      })
      .catch(({ message }) => {
        Toast({ type: "error", message });
        reject(message);
      });
  });
};

export const {
  saveTradeData,
  saveActivityData,
  saveInactiveActivityData,
  saveActivityDetail,
  saveUomData,
  saveRegionData,
  setSelectedTrade,
  clearSelectedTrade,
} = activitySlice.actions;

export default activitySlice.reducer;
